module.exports = __webpack_public_path__ + "img/google_ads_icon-v2.3c465659.svg";